import { BehaviorSubject } from 'rxjs';
import { UnknownNetworkError } from '../errors';
export class ProviderBase {
    constructor() {
        this.networksInternal$ = new BehaviorSubject([]);
        this.networks$ = this.networksInternal$;
        this.mutableProviders = {};
    }
    getNetworks() {
        return this.networksInternal$.getValue();
    }
    addNetwork(options) {
        const { network, rpcURL } = options;
        this.mutableProviders[network] = this.createDataProvider({ network, rpcURL });
        const networks = this.networksInternal$.value.filter((net) => network !== net).concat([network]);
        this.networksInternal$.next(networks);
    }
    async getUnclaimed(network, address) {
        return this.getProvider(network).getUnclaimed(address);
    }
    async getUnspentOutputs(network, address) {
        return this.getProvider(network).getUnspentOutputs(address);
    }
    async relayTransaction(network, transaction, networkFee) {
        return this.getProvider(network).relayTransaction(transaction, networkFee);
    }
    async getTransactionReceipt(network, hash, options) {
        return this.getProvider(network).getTransactionReceipt(hash, options);
    }
    async getInvocationData(network, hash) {
        return this.getProvider(network).getInvocationData(hash);
    }
    async testInvoke(network, transaction) {
        return this.getProvider(network).testInvoke(transaction);
    }
    async call(network, contract, method, params) {
        return this.getProvider(network).call(contract, method, params);
    }
    async getNetworkSettings(network) {
        return this.getProvider(network).getNetworkSettings();
    }
    async getBlockCount(network) {
        return this.getProvider(network).getBlockCount();
    }
    async getTransaction(network, hash) {
        return this.getProvider(network).getTransaction(hash);
    }
    async getOutput(network, input) {
        return this.getProvider(network).getOutput(input);
    }
    async getClaimAmount(network, input) {
        return this.getProvider(network).getClaimAmount(input);
    }
    read(network) {
        return this.getProvider(network);
    }
    async getAccount(network, address) {
        return this.getProvider(network).getAccount(address);
    }
    iterActionsRaw(network, options) {
        return this.getProvider(network).iterActionsRaw(options);
    }
    iterBlocks(network, options = {}) {
        return this.getProvider(network).iterBlocks(options);
    }
    getProvider(network) {
        const provider = this.mutableProviders[network];
        if (provider === undefined) {
            throw new UnknownNetworkError(network);
        }
        return provider;
    }
}

//# sourceMappingURL=ProviderBase.js.map
